import { customElement, html, classMap } from '@adobe/edex/ui/edex-lit';

import { EdexTagName } from '@adobe/edex/ui/shared/constants';
import { BaseElement } from '@adobe/edex/ui/components/base.element';
import { I18nKey } from '@adobe/edex/ui/shared/constants/i18n';
import { $t } from '@adobe/edex/ui/shared/config/i18n';

import styles from './form-error.lit.scss';

@customElement(EdexTagName.resourceFormError)
export class ResourceFormError extends BaseElement {
  static styles = styles;

  static get properties() {
    return {
      error: { type: String },
    };
  }

  error: I18nKey;

  render() {
    const { error } = this;
    return html`
      <p
        class="form-error ${classMap({ error: !!error })}"
        aria-live="polite"
        aria-relevant="additions removals"
        role="status"
      >
        ${error ? $t(error) : ''}
      </p>
    `;
  }
}
